import AppLayoutAdmin from "@/layouts/AppLayoutAdmin.vue";
import UserAuth from "@/pages/user/UserAuth.vue"


export default    
{
    path: "/user",
    name: "UserAuth",
    meta: { requiredAuth: true },
    component: AppLayoutAdmin,
    children: [
        {
            path: 'me',
            name: "UserAuthProfile",
            component: UserAuth,

        },
    ]
}